import React, { useState } from 'react'

type Props = {
  size?: number
  className?: string
  style?: React.CSSProperties
  /** Skip PNG — use vector mark only (e.g. sidebar where img crop reads as a dark box) */
  symbolOnly?: boolean
}

function BrandMarkSvg({ size, className, style, fill }: { size: number; className?: string; style?: React.CSSProperties; fill: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden
    >
      <polygon points="8,58 50,8 92,58 79,58 50,21 21,58" fill={fill} />
      <polygon points="21,63 50,92 79,63 66,63 50,80 34,63" fill={fill} />
      <polygon points="34,52 50,36 66,52 57,52 50,43 43,52" fill={fill} />
      <polygon points="43,60 50,67 57,60 53,60 50,63 47,60" fill={fill} />
      <polygon points="50,45 57,52 50,59 43,52" fill={fill} />
    </svg>
  )
}

/** 44.01 mark: PNG when available (cropped to orange mark), SVG fallback */
export default function BrandLogo({ size = 36, className, style, symbolOnly }: Props) {
  const [imgFailed, setImgFailed] = useState(false)
  const fill = 'var(--canyon)'

  if (symbolOnly || imgFailed) {
    return <BrandMarkSvg size={size} className={className} style={style} fill={fill} />
  }

  return (
    <img
      src="/4401-logo.png"
      width={size}
      height={size}
      alt=""
      className={className}
      style={{
        display: 'block',
        objectFit: 'cover',
        objectPosition: 'right center',
        ...style,
      }}
      onError={() => setImgFailed(true)}
    />
  )
}
